import * as THREE from 'three';
import TextureScene from './TextureScene';
import carousselVertexShader from './shaders/caroussel/vertex.glsl'
import carousselFragmentShader from './shaders/caroussel/fragment.glsl'
import { OrbitControls } from 'three/examples/jsm/Addons.js';
import MeshMover from './MeshMover';

// Set up the scene, camera, and renderer
const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
const canvas = document.querySelector('.webgl');

const renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true });
const textureLoader = new THREE.TextureLoader();
const screenWidthLimit = 950;



var isInMobile = window.innerWidth < screenWidthLimit;
var indexProjectInFront = 0;
var clock = new THREE.Clock();
var changingProject = false;
var canOpenProject = false;
var revealingCaroussel = false;
var removingCurve = false;
var displacement = {};
var loaded = false;
var canRender = true
const axesHelper = new THREE.AxesHelper();


const raycaster = new THREE.Raycaster();
const pointer = new THREE.Vector2();


function onPointerMove(event) {

    // calculate pointer position in normalized device coordinates
    // (-1 to +1) for both components

    pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
    pointer.y = - (event.clientY / window.innerHeight) * 2 + 1;

}
window.addEventListener('pointermove', onPointerMove);

/**
 * Sizes
 */
// Sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight

}

renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

const textureScene = new TextureScene(sizes)
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
//textureScene.scene.add( axesHelper );

camera.position.z = 1;
let ang_rad = 75.0 * Math.PI / 180;
let fov_y = camera.position.z * Math.tan(ang_rad / 2) * 2;




var planeGeometry =
    new THREE.PlaneGeometry((fov_y * sizes.width / sizes.height), fov_y, 100, 100);

function planeCurve(g, z) {

    let p = g.parameters;
    let hw = p.height * 0.5;

    let a = new THREE.Vector2(-hw, 0);
    let b = new THREE.Vector2(0, z);
    let c = new THREE.Vector2(hw, 0);

    let ab = new THREE.Vector2().subVectors(a, b);
    let bc = new THREE.Vector2().subVectors(b, c);
    let ac = new THREE.Vector2().subVectors(a, c);

    let r = (ab.length() * bc.length() * ac.length()) / (2 * Math.abs(ab.cross(ac)));

    let center = new THREE.Vector2(0, z - r);
    let baseV = new THREE.Vector2().subVectors(a, center);
    let baseAngle = baseV.angle() - (Math.PI * 0.5);
    let arc = baseAngle * 2;

    let uv = g.attributes.uv;
    let pos = g.attributes.position;
    let mainV = new THREE.Vector2();
    for (let i = 0; i < uv.count; i++) {
        let uvRatio = 1 - uv.getY(i);
        let y = pos.getX(i);
        mainV.copy(c).rotateAround(center, (arc * uvRatio));
        pos.setXYZ(i, y, mainV.x, -mainV.y);
    }

    pos.needsUpdate = true;

}


textureScene.initProjectCarousselPosition()
/**
 * 
 * Displacement
 */

//2D canvas
displacement.canvas = document.createElement('canvas');
displacement.canvas.width = 100;
displacement.canvas.height = 100;
displacement.canvas.style.position = 'fixed'
displacement.canvas.style.width = '512px'
displacement.canvas.style.height = '512px'
displacement.canvas.style.top = 0
displacement.canvas.style.left = 0
displacement.canvas.style.zIndex = 10
displacement.canvas.id = "distortion-canvas";



document.body.append(displacement.canvas);
//context

displacement.context = displacement.canvas.getContext('2d');
displacement.context.fillRect(0, 0, displacement.canvas.width, displacement.canvas.height);


//Glow image


displacement.glowImage = new Image();
displacement.glowImage.src = './brush.png';
//inteeactive plane


displacement.raycaster = new THREE.Raycaster();

displacement.screenCursor = new THREE.Vector2(9999, 9999);
displacement.canvasCursor = new THREE.Vector2(9999, 9999);
displacement.canvasPreviousCursor = new THREE.Vector2(9999, 9999);

displacement.texture = new THREE.CanvasTexture(displacement.canvas)



const planeMaterial = new THREE.ShaderMaterial({
    uniforms: {
        uTexture: { value: textureScene.renderTarget.texture },
        uGrayIntensity: { value: 1 },
        uProgress: { value: 0 },
        uDisplacementTexture: new THREE.Uniform(displacement.texture),


    },
    vertexShader: carousselVertexShader,
    fragmentShader: carousselFragmentShader,
    side: THREE.DoubleSide,
})

const plane = new THREE.Mesh(planeGeometry, planeMaterial);
displacement.interactivePlane = plane;

//plane.rotateX(-3.14/2);
//plane.rotateOnAxis(new THREE.Vector3(1,0,0), -Math.PI/2);
scene.add(plane);


function previousProject() {
    if (textureScene.canChangeProject) {
        //event.preventDefault();

        indexProjectInFront = mod(indexProjectInFront + 1, 4);
        clock = new THREE.Clock();
        changingProject = true
        textureScene.canChangeProject = false;
        textureScene.moveCaroussel(-1)
    }


};

function nextProject() {
    if (textureScene.canChangeProject) {

        indexProjectInFront = mod(indexProjectInFront - 1, 4);
        clock = new THREE.Clock();
        changingProject = true;
        textureScene.canChangeProject = false;

        textureScene.moveCaroussel(1)


    }

};
const getIndexInFront = () => {   
    return indexProjectInFront;
}
const getCanOpenProject = () => {
    return canOpenProject;
}
 const setCanRender=(value)=>{
    canRender=value;
 }
// Animation loop
function animate() {
    if (canRender) {
        if (sizes.width > screenWidthLimit) {
            if (revealingCaroussel) {
                const elapsedTime = clock.getElapsedTime();
                
                if (elapsedTime >= 1.5) {
                    revealingCaroussel = false;
                    removingCurve = true;
                    clock = new THREE.Clock();
                }
            }
            else if (removingCurve) {
                const elapsedTime = clock.getElapsedTime();

                if (elapsedTime < 1) {
                    const curve = -0.5 + MeshMover.easings.easeInOutCubic(elapsedTime) * 0.5;
                    planeCurve(planeGeometry, curve - 0.001);
                    textureScene.elementList.forEach((element, i) => {
                        element.material.uniforms.uProgress.value = 1 - MeshMover.easings.easeInOutCubic(elapsedTime);

                    });
                }
                else {
                    removingCurve = false;
                    textureScene.canChangeProject = true;
                    loaded = true;
                }

            }
            else if (loaded) {
                // update the picking ray with the camera and pointer position
                raycaster.setFromCamera(pointer, textureScene.camera);
                displacement.raycaster.setFromCamera(pointer, camera);

                // calculate objects intersecting the picking ray
                const projectIntersections = raycaster.intersectObjects(textureScene.elementList, false);
                const planeIntersections = displacement.raycaster.intersectObject(displacement.interactivePlane, false);

                if (projectIntersections.length) {
                    const uv = projectIntersections[0].uv;
                    /* concernedMesh = intersections[0].object;
                     */
                    canOpenProject = true;

                } else {
                    canOpenProject = false;
                }

                if (planeIntersections.length) {
                    const uv = planeIntersections[0].uv;

                    displacement.canvasCursor.x = uv.x * displacement.canvas.width
                    displacement.canvasCursor.y = (1 - uv.y) * displacement.canvas.height
                }

                /**
                * displacement
                */
                displacement.context.globalCompositeOperation = 'source-over'
                displacement.context.globalAlpha = 0.02
                displacement.context.fillRect(0, 0, displacement.canvas.width, displacement.canvas.height)

                //speed alpha
                const cursorDisance = displacement.canvasPreviousCursor.distanceTo(displacement.canvasCursor);
                displacement.canvasPreviousCursor.copy(displacement.canvasCursor);
                const alpha = Math.min(1, cursorDisance * 0.1);
                //draw glow
                const glowSize = displacement.canvas.width * 0.15;
                displacement.context.globalCompositeOperation = 'lighten';
                displacement.context.globalAlpha = alpha;



                displacement.context.drawImage(
                    displacement.glowImage,
                    displacement.canvasCursor.x - glowSize * 0.5,
                    displacement.canvasCursor.y - glowSize * 0.5,
                    glowSize,
                    glowSize
                )
                //const newUniform= new THREE.Uniform(displacement.texture)

                displacement.texture.needsUpdate = true;



                if (changingProject) {

                    const elapsedTime = clock.getElapsedTime() * 0.8
                    if (elapsedTime <= 0.5) {
                        planeMaterial.uniforms.uProgress.value = elapsedTime;
                        planeCurve(planeGeometry, -0.5 * MeshMover.easings.easeInOutQuad(elapsedTime * 2) - 0.001);
                        textureScene.elementList.forEach((element, i) => {
                            element.material.uniforms.uProgress.value = MeshMover.easings.easeInOutQuad(elapsedTime * 2);
                        });
                    }
                    else if (elapsedTime >= 0.5) {
                        clock = new THREE.Clock();
                        changingProject = false;
                        removingCurve = true;
                    }


                }
            }


            // Render the texture scene to the render target
            renderer.setRenderTarget(textureScene.renderTarget);
            renderer.render(textureScene.scene, textureScene.camera);

            // Reset render target and render the main scene
            renderer.setRenderTarget(null);
            renderer.render(scene, camera);



        }
        requestAnimationFrame(animate);
    }

}

// Handle window resizing
window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;
    if (sizes.width > screenWidthLimit) {
        if (isInMobile) {
            window.location.reload();
        }
        // Update camera
        textureScene.camera.aspect = sizes.width / sizes.height;

        textureScene.camera.updateProjectionMatrix();
        // Update plane geometry to match new aspect ratio

        // Update renderer
        renderer.setSize(sizes.width, sizes.height);
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    }
    else {
        if (!isInMobile) {

            window.location.reload();
        }
    }
});

function mod(n, m) {
    return ((n % m) + m) % m;
}


function revealCaroussel() {
    planeCurve(planeGeometry, -0.5);
    textureScene.elementList.forEach((element, i) => {
        element.material.uniforms.uProgress.value = 1 ;

    });
    clock = new THREE.Clock();
    revealingCaroussel = true;
    textureScene.revealCaroussel(2);
}
function revealInstantCaroussel(){
    textureScene.revealCaroussel(0);
    textureScene.canChangeProject = true;
    loaded = true;
}

function revealInstantCarousselAtProject(i){
    indexProjectInFront=i;
    textureScene.revealCarousselAt(i);
    textureScene.canChangeProject = true;
    loaded = true;
}
function getLoadedValue(){
    return loaded;
}
// Start the animation
animate();

export { getLoadedValue,revealInstantCarousselAtProject, revealInstantCaroussel,revealCaroussel, getIndexInFront, previousProject, nextProject, getCanOpenProject };